import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import {
  Section,
  Wrapper,
  Interests,
  Interest,
  Header,
  InterestRate,
  StyledCtas,
} from './styles';

const InterestRates = ({ data }) => {
  if (!data) return null;
  const {
    backgroundColor,
    backgroundImage,
    headingColor,
    listOfFeatures,
    ctas,
  } = data;

  const interestLength = listOfFeatures.length || 1;

  const heading = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Header $headingColor={headingColor}>{children}</Header>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Header $headingColor={headingColor}>{children}</Header>
      ),
    },
  };

  const interest = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <InterestRate>{children}</InterestRate>
      ),
    },
  };

  return (
    <Section
      className={`${backgroundColor}`}
      $backgroundImage={backgroundImage}
      $backgroundColor={backgroundColor}
    >
      <Wrapper>
        {listOfFeatures && (
          <Interests $interestLength={interestLength}>
            {listOfFeatures.map(
              ({ id, heading: interestHeader, description }) => {
                return (
                  <Interest key={id}>
                    {description && (
                      <RichText document={description} options={heading} />
                    )}
                    {interestHeader && (
                      <RichText document={interestHeader} options={interest} />
                    )}
                  </Interest>
                );
              },
            )}
          </Interests>
        )}
        {ctas && <StyledCtas ctas={ctas} direction="row" alignment="center" />}
      </Wrapper>
    </Section>
  );
};

InterestRates.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default InterestRates;
